import { EventEmitter } from '@angular/core';

export class OverlayRef<T = any> {
    readonly closed = new EventEmitter<T>();

    close(result: T) {
        this.closed.emit(result);
    }
}
